import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@piplapps/pipl-ui';
import { Helmet } from 'react-helmet';
import styles from './Dashboard.module.less';

const Dashboard = (props) => {
  useEffect(() => {
    props.getUsageAnalytics();
  }, []);
  const handleTimeFilterChange = (timeRange) => {
    props.getUsageAnalytics({
      start_date: timeRange.selection.startDate.toDateString(),
      end_date: timeRange.selection.endDate.toDateString(),
    });
  };
  const fields = props.usageAnalyticsData?.percentages;
  const getFieldData = (field) => [
    { angle: fields ? fields[field].single_match : null, color: '#d9e0eb' },
    { angle: fields ? fields[field].multiple_match : null, color: '#7642d6' },
    { angle: fields ? fields[field].no_match : null, color: '#3ba2ff' },
  ];
  const getFieldPercentage = (field) => (fields ? `${fields[field].total_from_searches}%` : null);
  const labelDict = {
    email: 'Email',
    address: 'Address',
    phone: 'Phone',
    name_address: 'Name, Address',
    other: 'Other',
  };
  const getFieldLabel = (field) => labelDict[field];
  const data = fields
    ? Object.keys(fields).map((field) => {
        return {
          name: field,
          title: getFieldLabel(field),
          data: getFieldData(field),
          percentage: getFieldPercentage(field),
        };
      })
    : [];

  const labelStyle = { fontSize: 14, fontWeight: 'bold' };
  const timeUsage = props.usageAnalyticsData?.time_usage;
  const graphData = timeUsage
    ? Object.keys(timeUsage).map((month) => {
        return { x: month, y: timeUsage[month], style: labelStyle, yOffset: -20, xOffset: -20 };
      })
    : [];

  return (
    <>
      <Helmet>
        <title>{gettext('Dashboard')}</title>
      </Helmet>
      <DatePicker onDateSelection={handleTimeFilterChange} />
      <div className={styles.title}>{gettext('Top search types')}</div>
      <div className={styles.sectionWrapper}>
        <div>{gettext('Most performed searches decomposed by search types.')}</div>
        <div className={styles.map}>
          <div className={styles.squareContainer}>
            <div className={[styles.square, styles.purple].join(' ')} />
            <div className={styles.categoryText}>{gettext('Single Match')}</div>
          </div>
          <div className={styles.squareContainer}>
            <div className={[styles.square, styles.blue].join(' ')} />
            <div className={styles.categoryText}>{gettext('Multiple Match')}</div>
          </div>
          <div className={styles.squareContainer}>
            <div className={[styles.square, styles.grey].join(' ')} />
            <div className={styles.categoryText}>{gettext('No Match')}</div>
          </div>
        </div>
      </div>
      <div className={styles.pieChartsWrapper}>
        {data?.map((chart) => {
          return (
            <div key={chart.name}>
              <div className={styles.percentage}>{chart.percentage}</div>
              <div className={styles.field}>{chart.title}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.title}>{gettext('Performed searches')}</div>
      <div></div>
    </>
  );
};

Dashboard.propTypes = {
  usageAnalyticsData: PropTypes.object,
  getUsageAnalytics: PropTypes.func,
};

export default Dashboard;
